module.exports = __webpack_public_path__ + "static/img/entry-skeleton.b9b5433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skeleton/entry-skeleton.png
// module id = XJ6Q
// module chunks = 17